import React from 'react';
import bannerImage from '../assets/bg.png';
import Redemly1 from '../assets/Redemly/11.jpeg';
import Redemly2 from '../assets/Redemly/22.jpeg';
import Redemly3 from '../assets/Redemly/33.jpeg';
import Redemly4 from '../assets/Redemly/44.jpeg';
import Redemly5 from '../assets/Redemly/55.jpeg';
import Redemly6 from '../assets/Redemly/66.jpeg';
import Redemly7 from '../assets/Redemly/77.jpeg';
import Redemly8 from '../assets/Redemly/88.jpeg';
import Redemly9 from '../assets/Redemly/99.jpeg';
import Redemly10 from '../assets/Redemly/110.jpeg';
import Redemly11 from '../assets/Redemly/120.jpeg';
import Redemlyweb1 from '../assets/Redemly/web1.png';
import Redemlyweb2 from '../assets/Redemly/web2.png';
import Redemlyweb3 from '../assets/Redemly/web3.png';
import Redemlyweb4 from '../assets/Redemly/web4.png';
import Redemlyweb5 from '../assets/Redemly/web5.png';
import PMS1 from '../assets/PMS/1.png';
import PMS2 from '../assets/PMS/2.png';
import PMS3 from '../assets/PMS/3.png';
import PMS4 from '../assets/PMS/4.png';
import PMS5 from '../assets/PMS/5.png';
import PMS6 from '../assets/PMS/6.png';
import PMS7 from '../assets/PMS/7.png';
import Bing1 from '../assets/Bingenjoy/1.png';
import Bing2 from '../assets/Bingenjoy/2.png';
import Bing3 from '../assets/Bingenjoy/3.png';
import Bing4 from '../assets/Bingenjoy/4.png';
import Bing5 from '../assets/Bingenjoy/5.png';
import Bing6 from '../assets/Bingenjoy/6.png';
import Bing7 from '../assets/Bingenjoy/7.png';
import Bing8 from '../assets/Bingenjoy/8.png';
import Carnival1 from '../assets/Carnival/1.png';
import Carnival2 from '../assets/Carnival/2.png';
import Carnival3 from '../assets/Carnival/3.png';
import Carnival4 from '../assets/Carnival/4.png';
import Carnival5 from '../assets/Carnival/5.png';
import Carnival6 from '../assets/Carnival/6.png';
import Carnival7 from '../assets/Carnival/7.png';
import Carnival8 from '../assets/Carnival/8.png';
import Carnival9 from '../assets/Carnival/9.png';
import veg1 from '../assets/Vegiffy/1.jpeg';
import veg2 from '../assets/Vegiffy/2.jpeg';
import veg3 from '../assets/Vegiffy/3.jpeg';
import veg4 from '../assets/Vegiffy/4.jpeg';
import veg5 from '../assets/Vegiffy/5.jpeg';
import veg6 from '../assets/Vegiffy/6.jpeg';
import veg7 from '../assets/Vegiffy/7.jpeg';
import veg8 from '../assets/Vegiffy/8.jpeg';
import veg9 from '../assets/Vegiffy/9.jpeg';
import veg10 from '../assets/Vegiffy/10.jpeg';
import vegweb1 from '../assets/Vegiffy/web1.png'
import vegweb2 from '../assets/Vegiffy/web2.png'
import vegweb3 from '../assets/Vegiffy/web3.png'
import vegweb4 from '../assets/Vegiffy/web4.png'
import vegweb5 from '../assets/Vegiffy/web5.png'
import vegweb6 from '../assets/Vegiffy/web6.png'
import vegweb7 from '../assets/Vegiffy/web7.png'
import Varahi1 from '../assets/Varahi/1.jpeg';
import Varahi2 from '../assets/Varahi/2.jpeg';
import Varahi3 from '../assets/Varahi/3.jpeg';
import Varahi4 from '../assets/Varahi/4.jpeg';
import Varahi5 from '../assets/Varahi/5.jpeg';
import Varahi6 from '../assets/Varahi/6.jpeg';
import Varahi7 from '../assets/Varahi/7.jpeg';
import Varahi8 from '../assets/Varahi/8.jpeg';
import Varahi9 from '../assets/Varahi/9.jpeg';
import Varahi10 from '../assets/Varahi/10.jpeg';
import Varahiweb1 from '../assets/Varahi/web1.png';
import Varahiweb2 from '../assets/Varahi/web2.png';
import Varahiweb3 from '../assets/Varahi/web3.png';
import Varahiweb4 from '../assets/Varahi/web4.png';
import Varahiweb5 from '../assets/Varahi/web5.png';
import Varahiweb6 from '../assets/Varahi/web6.png';
import Tech1 from '../assets/Techsterker/1.png';
import Tech2 from '../assets/Techsterker/2.png';
import Tech3 from '../assets/Techsterker/3.png';
import Tech4 from '../assets/Techsterker/4.png';
import Tech5 from '../assets/Techsterker/5.png';
import Tech6 from '../assets/Techsterker/6.png';
import Tech7 from '../assets/Techsterker/7.png';
import Tech8 from '../assets/Techsterker/8.png';
import Tech9 from '../assets/Techsterker/9.png';
import Tech10 from '../assets/Techsterker/10.png';
import Tech11 from '../assets/Techsterker/11.png';
import Narada1 from '../assets/Narada/1.jpeg';
import Narada2 from '../assets/Narada/2.jpeg';
import Narada3 from '../assets/Narada/3.jpeg';
import Narada4 from '../assets/Narada/4.jpeg';
import Narada5 from '../assets/Narada/5.jpeg';
import Narada6 from '../assets/Narada/6.jpeg';
import Narada7 from '../assets/Narada/7.jpeg';
import Narada8 from '../assets/Narada/8.jpeg';
import Narada9 from '../assets/Narada/9.jpeg';
import Narada10 from '../assets/Narada/10.jpeg';
import Narada11 from '../assets/Narada/11.jpeg';
import Naradaweb from '../assets/Narada/web.png'
import ss1 from '../assets/ss/1.png';
import ss2 from '../assets/ss/2.png';
import ss3 from '../assets/ss/3.png';
import ss4 from '../assets/ss/4.png';
import ss5 from '../assets/ss/5.png';
import ss6 from '../assets/ss/6.png';
import ss7 from '../assets/ss/7.png';
import ss8 from '../assets/ss/8.png';
import editweb1 from '../assets/EditEZY/web1.png';
import editweb2 from '../assets/EditEZY/web2.png';
import Nupura1 from '../assets/Nupura/1.jpeg';
import Nupura2 from '../assets/Nupura/2.jpeg';
import Nupuraweb from '../assets/Nupura/web.png';
import Simcurax1 from '../assets/Clynix/web1.png';
import Simcurax2 from '../assets/Clynix/web2.png';
import Simcurax3 from '../assets/Clynix/web3.png';
import Simcurax4 from '../assets/Clynix/web4.png';
import Simcurax5 from '../assets/Clynix/web5.png';
import Cynix1 from '../assets/Clynix/1.jpeg';
import Cynix2 from '../assets/Clynix/2.jpeg';
import Cynix3 from '../assets/Clynix/3.jpeg';
import Cynix4 from '../assets/Clynix/4.jpeg';
import Cynix5 from '../assets/Clynix/5.jpeg';
import Cynix6 from '../assets/Clynix/6.jpeg';
import Cynix7 from '../assets/Clynix/7.jpeg';
import Cynix8 from '../assets/Clynix/8.jpeg';
import EditEZY1 from '../assets/EditEZY/1.jpeg';
import EditEZY2 from '../assets/EditEZY/2.jpeg';
import EditEZY3 from '../assets/EditEZY/3.jpeg';
import EditEZY4 from '../assets/EditEZY/4.jpeg';
import EditEZY5 from '../assets/EditEZY/5.jpeg';
import EditEZY6 from '../assets/EditEZY/6.jpeg';
import EditEZY7 from '../assets/EditEZY/7.jpeg';
import EditEZY8 from '../assets/EditEZY/8.jpeg';
import EditEZY9 from '../assets/EditEZY/9.jpeg';
import EditEZY10 from '../assets/EditEZY/10.jpeg';
import EditEZY11 from '../assets/EditEZY/11.jpeg';
import EditEZY12 from '../assets/EditEZY/12.jpeg';
import EditEZY13 from '../assets/EditEZY/13.jpeg';
import EditEZY14 from '../assets/EditEZY/14.jpeg';
import Back1 from '../assets/Backup/1.jpeg';
import Back2 from '../assets/Backup/2.jpeg';
import Back3 from '../assets/Backup/3.jpeg';
import Back4 from '../assets/Backup/4.jpeg';
import Back5 from '../assets/Backup/5.jpeg';
import Back6 from '../assets/Backup/6.jpeg';
import Back7 from '../assets/Backup/7.jpeg';
import Back8 from '../assets/Backup/8.jpeg';
import Back9 from '../assets/Backup/9.jpeg';
import Back10 from '../assets/Backup/10.jpeg';
import Back11 from '../assets/Backup/11.jpeg';




//Banner Images for Projects
import Tech from '../assets/ProjectBanners/techsterker.jpeg';
import Bingenjoy from '../assets/ProjectBanners/bingenjoy.jpeg';
import Carnival from '../assets/ProjectBanners/carnival.jpeg';
import EditEZY from '../assets/ProjectBanners/editezy.jpeg';
import Narada from '../assets/ProjectBanners/narada.jpeg';
import Simcura from '../assets/ProjectBanners/simcura.jpeg';
import SSAir from '../assets/ProjectBanners/ssair.jpeg';
import Varahi from '../assets/ProjectBanners/varahi.jpeg';
import PMS from '../assets/ProjectBanners/pms.png';
import VEG from '../assets/ProjectBanners/veg.png';
import Redemly from '../assets/ProjectBanners/redemly.png';
import Nupura  from '../assets/ProjectBanners/nupura.png';
import Backup from '../assets/ProjectBanners/backup.png';
import App from '../assets/ProjectBanners/app.jpeg';
 


// Complete portfolio data
const portfolioItems = [
    {
        id: 1, 
        title: "PIXELMINDSOLUTIONS", 
        type: "website",
        description: "Pixelmind Solutions is a leading IT services provider, offering innovative solutions in website development, mobile application design, and digital marketing.",
        fullDescription: "Pixelmind Solutions is a leading IT services provider, offering innovative solutions in website development, mobile application design, and digital marketing. Dedicated to helping businesses thrive in the digital world by delivering tailored, high-quality services that enhance user experiences, drive growth, and build a strong online presence. With a team of expert developers, designers, and strategists, we transform ideas into powerful digital experiences.",
        image: "/assets/images/banner/pixelmind.jpg", 
        icon: "/assets/images/logo/pixelmind.jpg",
        websiteLink: "https://www.pixelmindsolutions.com/",
        client: "PixelMind Solutions",
        category: "Web Development",
        year: "2024",
        duration: "4 Months",
        technologies: ["React", "Node.js", "MongoDB", "AWS", "Figma", "Tailwind CSS"],
        features: ["Responsive Design", "SEO Optimized", "Analytics Dashboard", "Content Management", "Multi-language Support", "Payment Gateway"],
        results: { "Traffic": "+150%", "Conversion": "+35%", "Engagement": "+85%", "Speed": "1.2s" },
        challenges: "Integrating multiple third-party services while maintaining performance.",
        solution: "Implemented microservices architecture with React frontend.",
        testimonial: { name: "John Doe", position: "CEO, PixelMind Solutions", text: "Exceptional product delivered! The team exceeded our expectations." },
        screenshots: [PMS1, PMS2, PMS3, PMS4, PMS5, PMS6, PMS7],
        BackgroundImage: PMS,
    },
    {
        id: 3, 
        title: "BingeNJoy – Private Theatre Booking & Celebration Platform", 
        type: "website",
        description: "BingeNJoy is a private theatre booking platform that offers exclusive movie screening experiences for birthdays, anniversaries, proposals, family gatherings, and other special occasions. It provides premium private theatres with customizable celebration packages, making events more memorable and personalized.",
        fullDescription: "BingeNJoy is an entertainment and event booking platform that allows users to book luxury private theatres for personal celebrations. Customers can enjoy movies in a private cinema equipped with 4K Ultra HD projection, Dolby Atmos sound, and comfortable recliner seating. The platform also offers customized decorations, cakes, food and beverage packages, photography, romantic setups, birthday themes, anniversary celebrations, baby showers, and other event services. Users can stream movies using their own OTT accounts while enjoying a premium and hassle-free celebration experience. BingeNJoy simplifies the entire event planning process by combining venue booking, entertainment, and celebration services in one platform.",
        image: "/assets/images/banner/binenjoy.jpg", 
        icon: "/assets/images/logo/binenjoy.png",
        websiteLink: "https://bingenjoy.com/",
        client: "Bingenjoy Entertainment",
        category: "Entertainment, Private Theatre Booking, Event Management, Celebration Venue, Hospitality",
        year: "2024",
        duration: "3 Months",
        technologies: ["React", "Express", "PostgreSQL", "Stripe", "Cloudinary"],
        features: [
            "Private theatre booking", 
            "4K Ultra HD movie projection", 
            "Dolby Atmos surround sound", 
            "Luxury recliner seating", 
            "Birthday celebration packages", 
            "Anniversary celebration packages", 
            "Proposal and romantic setups", 
            "Baby shower celebration packages", 
            "Cake booking", 
            "Customized decoration themes", 
            "Food and beverage services", 
            "OTT account streaming support", 
            "Photography support", 
            "Online booking system",
            "Multiple theatre locations",
            "Personalized celebration packages", 
            "Customer support via WhatsApp"
        ],
        results: { "Bookings": "+200%", "Revenue": "+45%", "Users": "+5000", "Satisfaction": "98%" },
        challenges: "Lack of privacy in traditional movie theatres. Limited options for celebrating special occasions in a unique way. Managing venue, decorations, food, and entertainment separately. Finding premium spaces for couples, families, and small groups. Time-consuming event planning process.",
        solution: "BingeNJoy provides an all-in-one private theatre and celebration platform where users can book exclusive cinema spaces along with decoration, food, cakes, photography, and customized event services. The platform delivers a premium entertainment experience while simplifying event planning through a single online booking system, making celebrations convenient, private, and memorable.",
        testimonial: { name: "Sarah Johnson", position: "Event Manager", text: "Transformed our booking process completely!" },
        screenshots: [
            Bing1,
            Bing2,
            Bing3,
            Bing4,
            Bing5,
            Bing6,
            Bing7,
            Bing8
        ],
        BackgroundImage: Bingenjoy,
    },
    {
        id: 4, 
        title: "Carnival Castle – Private Theatre & Celebration Booking Platform", 
        type: "website",
        description: "Carnival Castle is a premium private theatre and celebration platform in Hyderabad that offers exclusive movie experiences for birthdays, anniversaries, proposals, baby showers, kids' parties, and other special occasions. It combines private cinema entertainment with customized event planning to create memorable celebrations.",
        fullDescription: "Carnival Castle is a one-stop destination for booking luxury private theatres and celebration packages in Hyderabad. The platform allows customers to reserve private screening rooms equipped with premium audio-visual systems and customize their events with themed decorations, cakes, food, bouquets, photography, and personalized add-ons. Users can celebrate birthdays, anniversaries, proposals, kids' parties, corporate events, and family gatherings while enjoying movies through their preferred OTT accounts. With multiple branches across Hyderabad and a simple online booking process, Carnival Castle delivers an end-to-end celebration experience that is private, convenient, and memorable.",
        image: "/assets/images/banner/carnival.jpg", 
        icon: "/assets/images/logo/carnival.png",
        websiteLink: "https://carnivalcastle.com/",
        client: "Carnival Castle",
        category: "Entertainment, Private Theatre Booking, Event Management, Celebration Venue, Hospitality, Party Planning",
        year: "2024",
        duration: "3 Months",
        technologies: ["React", "Firebase", "Tailwind", "Stripe", "SendGrid"],
        features: [
            "Online private theatre booking",
            "Luxury private screening rooms",
            "Birthday celebration packages",
            "Anniversary celebration packages",
            "Proposal and romantic setups",
            "Kids' birthday party packages",
            "Baby shower celebrations",
            "Corporate event bookings",
            "15+ themed decoration options",
            "Custom cakes",
            "Food and beverage services",
            "Professional photography",
            "Bouquets and surprise add-ons",
            "OTT movie screening support",
            "Secure online payment",
            "Multiple Hyderabad locations",
            "WhatsApp booking assistance",
            "Personalized celebration packages",
            "Fast and hassle-free booking process"
        ],
        results: { "Bookings": "+180%", "Revenue": "+60%", "Visitors": "+10000", "Rating": "4.9/5" },
        challenges: "Traditional theatres do not offer privacy for personal celebrations. Organizing decorations, food, cakes, photography, and entertainment separately is time-consuming. Limited venues provide customized celebration experiences. Finding a premium yet affordable private event space can be difficult. Planning surprise celebrations requires coordination with multiple vendors.",
        solution: "Carnival Castle simplifies celebration planning by providing an all-in-one private theatre booking platform. Customers can book exclusive theatre spaces along with customized decorations, cakes, food, photography, bouquets, and entertainment through a single booking process. The platform delivers a premium, private, and hassle-free celebration experience for couples, families, friends, and corporate groups.",
        testimonial: { name: "Mike Wilson", position: "Director", text: "Amazing platform for our venues!" },
        screenshots: [
            Carnival1,
            Carnival2,
            Carnival3,
            Carnival4,
            Carnival5,
            Carnival6,
            Carnival7,
            Carnival8,
            Carnival9
        ],
        BackgroundImage: Carnival,
    },
    {
        id: 7, 
        title: "VEGIFFY – 100% Pure Vegetarian Food Delivery Platform", 
        type: "app",
        description: "VEGIFFY is a dedicated food delivery platform exclusively for pure vegetarian food. It connects customers with verified vegetarian restaurants, cloud kitchens, sweet shops, juice centers, and delivery partners, ensuring a trusted, hygienic, and convenient vegetarian dining experience.",
        fullDescription: "VEGIFFY is India's dedicated 100% pure vegetarian food delivery platform, operated by Jainity Eats India Private Limited. The platform is built for people who prefer vegetarian food for health, cultural, religious, or lifestyle reasons. VEGIFFY partners only with verified vegetarian restaurants, hotels, cloud kitchens, sweet shops, and food vendors to guarantee food purity. Customers can browse restaurants, place orders, track deliveries in real time, and enjoy affordable pricing with free delivery on eligible orders. In addition to serving customers, VEGIFFY also empowers restaurant owners, delivery partners, and campus ambassadors by providing business growth and earning opportunities. The platform aims to build India's most trusted vegetarian food ecosystem with quality service, fast delivery, and complete transparency.",
        image: "/assets/portfolio/veg.jpeg", 
        icon: "/assets/portfolio/veglogo.png",
        playstoreLink: "https://play.google.com/store/apps/details?id=com.veggify.veegify",
        appstoreLink: "https://apps.apple.com/in/app/vegiffy/id6757138352",
        client: "Vegiffy Foods",
        category: "Food Delivery, Online Food Ordering, Pure Vegetarian Platform, Restaurant Marketplace, Food & Beverage, E-commerce",
        year: "2024",
        duration: "5 Months",
        technologies: ["React Native", "Node.js", "MongoDB", "Firebase", "Google Maps", "Stripe"],
        features: [
            "100% Pure Vegetarian food delivery",
            "Verified vegetarian restaurants and vendors",
            "Online food ordering",
            "Real-time order tracking",
            "Free delivery on eligible orders",
            "Fast delivery service",
            "Hygienic and quality-assured food",
            "Affordable pricing and offers",
            "Restaurant discovery",
            "Cloud kitchen support",
            "Sweet shop and juice center listings",
            "Vendor registration portal",
            "Delivery partner registration",
            "Campus ambassador program",
            "Mobile app for Android and iOS",
            "Secure online ordering",
            "Customer support",
            "Multi-city expansion",
            "Vendor business management",
            "Easy partner onboarding"
        ],
        results: { "Orders": "+300%", "Restaurants": "+200", "Users": "+15000", "Delivery": "25min avg" },
        challenges: "Difficulty finding trusted 100% vegetarian restaurants. Concerns about food purity and cross-contamination. Limited platforms dedicated exclusively to vegetarian customers. Small vegetarian businesses struggle to reach more customers. Lack of a unified ecosystem for customers, vendors, and delivery partners.",
        solution: "VEGIFFY solves these challenges by providing a dedicated platform exclusively for pure vegetarian food. It verifies every restaurant partner, ensures strict vegetarian standards, offers fast and reliable delivery, and creates growth opportunities for vendors and delivery partners. By combining trusted food delivery, business support, and a vegetarian-focused marketplace, VEGIFFY delivers a complete and reliable ecosystem for the vegetarian community.",
        testimonial: { name: "Priya Sharma", position: "CEO, Vegiffyy", text: "Revolutionized vegetarian food delivery!" },
        screenshots: [
            veg1,
            veg2,
            veg3,
            veg4,
            veg5,
            veg6,
            veg7,
            veg8,
            veg9,
            veg10
        ],
        videoLabel: "Watch Demo",
        videoId: "TafWxd87uUs",
        BackgroundImage: VEG,
    },
    {
        id: 8, 
        title: "Redemly – Earn Coins, Redeem Local Rewards", 
        type: "app",
        description: "Redemly is a rewards and loyalty platform that enables users to earn coins by completing fun daily activities such as walking, quizzes, reading articles, and spinning a reward wheel. The earned coins can be redeemed for discounts and offers at local businesses, helping users save money while supporting their local community.",
        fullDescription: "Redemly is a gamified rewards platform designed to encourage healthy habits, learning, and community engagement. Users can earn reward coins by tracking their daily steps, completing quizzes, reading informative content, learning interesting facts, and participating in daily 'Spin to Win' activities. These coins can then be redeemed for discounts, coupons, and exclusive offers at participating local grocery stores, restaurants, cafés, retail shops, and other neighborhood businesses. The platform benefits both users and merchants by increasing customer engagement, promoting local businesses, and providing an enjoyable way to earn everyday savings. Redemly also offers a Pro solution for businesses to distribute unlimited coupons and customer rewards.",
        image: "/assets/portfolio/redemly.png", 
        icon: "/assets/portfolio/redemlylogo.png",
        playstoreLink: "https://play.google.com/store/apps/details?id=com.srikanth.redeemly",
        appstoreLink: "https://apps.apple.com/in/app/redemly/id6755115759",
        client: "Redemly Inc",
        category: "Rewards Platform, Loyalty Program, Local Business Marketplace, Gamification, Lifestyle, Mobile Application",
        year: "2024",
        duration: "4 Months",
        technologies: ["Flutter", "Firebase", "Node.js", "PostgreSQL", "Redis"],
        features: [
            "Earn coins through daily activities",
            "Step tracking and fitness rewards",
            "Daily quizzes with coin rewards",
            "Read Buzz Boards to earn coins",
            "Learn Facts and earn rewards",
            "Daily Spin-to-Win bonus",
            "Coin redemption at local businesses",
            "Grocery store discounts",
            "Restaurant and café offers",
            "Retail shopping discounts",
            "Local business marketplace",
            "Mobile app for Android and iOS",
            "User-friendly reward dashboard",
            "Community engagement platform",
            "Business loyalty and coupon programs",
            "Redemly Pro for merchants",
            "Interactive and gamified experience",
            "Secure reward redemption system"
        ],
        results: { "Users": "+25000", "Partners": "+150", "Redeems": "+10000", "Rating": "4.8/5" },
        challenges: "Low customer engagement for local businesses. Limited customer loyalty programs for neighborhood stores. Lack of motivation for healthy and educational daily habits. Difficulty discovering local discounts and offers. Small businesses struggle to attract and retain customers.",
        solution: "Redemly addresses these challenges by combining gamification with local commerce. Users earn coins through healthy and engaging activities like walking, quizzes, reading, and daily challenges, then redeem those coins for discounts at nearby businesses. This creates a win-win ecosystem where users save money while local merchants increase customer engagement, loyalty, and repeat visits through a single rewards platform.",
        testimonial: { name: "Alex Chen", position: "Founder, Redemly", text: "Amazing platform for rewards management!" },
        screenshots: [
            Redemly1,
            Redemly2,
            Redemly3,
            Redemly4,
            Redemly5,
            Redemly6,
            Redemly7,
            Redemly8,
            Redemly9,
            Redemly10,
            Redemly11
        ],
        videoLabel: "Watch Demo",
        videoId: "QcvN_Pc4ue8",
        BackgroundImage: Redemly,
    },
    {
        id: 9, 
        title: "Editesy – Professional Photo Editing & Image Retouching Services", 
        type: "app",
        description: "Editesy is a professional photo editing and image retouching service provider specializing in high-quality image editing solutions for eCommerce businesses, photographers, brands, agencies, and studios. The platform delivers fast, accurate, and affordable editing services to help businesses enhance their visual content.",
        fullDescription: "Editesy is a human-powered professional image editing platform that offers a wide range of photo editing and retouching services for eCommerce stores, product photographers, fashion brands, advertising agencies, and professional studios. Its team of experienced editors uses industry-standard tools to perform background removal, clipping paths, image masking, ghost mannequin effects, color correction, photo retouching, shadow creation, jewelry retouching, and other advanced editing services. The platform focuses on delivering high-quality, pixel-perfect images with quick turnaround times, helping businesses improve product presentation, increase customer engagement, and boost online sales. Editesy serves clients worldwide with scalable editing solutions and dedicated customer support.",
        image: "/assets/portfolio/editezy.png", 
        icon: "/assets/portfolio/editezy.png",
        playstoreLink: "https://play.google.com/store/apps/details?id=com.posternova.posternova",
        appstoreLink: "https://apps.apple.com/in/app/editezy/id6753908761",
        client: "EditEZY Studios",
        category: "Photo Editing, Image Retouching, eCommerce Services, Creative Services, Digital Media, Outsourcing",
        year: "2024",
        duration: "6 Months",
        technologies: ["React Native", "Node.js", "MongoDB", "AWS S3", "WebGL", "Canvas"],
        features: [
            "Professional photo editing",
            "Background removal",
            "Clipping path services",
            "Image masking",
            "Ghost mannequin editing",
            "Color correction",
            "Photo retouching",
            "Shadow creation",
            "Jewelry retouching",
            "Product image enhancement",
            "eCommerce image optimization",
            "Bulk image editing",
            "High-quality manual editing",
            "Fast turnaround time",
            "Quality assurance process",
            "Dedicated editing experts",
            "Affordable pricing",
            "Secure file handling",
            "24/7 customer support",
            "Worldwide service delivery"
        ],
        results: { "Users": "+50000", "Templates": "+500", "Downloads": "+10000", "Satisfaction": "97%" },
        challenges: "Low-quality product images reduce customer trust and conversions. Manual image editing is time-consuming for businesses. Maintaining consistent image quality across large catalogs is difficult. Professional editing requires skilled designers and expensive software. Fast delivery of high-quality edited images is challenging for growing businesses.",
        solution: "Editesy solves these challenges by providing expert human-powered photo editing services with fast turnaround times and consistent quality. Businesses can outsource their image editing requirements to experienced professionals, ensuring visually appealing product images that improve brand presentation, enhance customer confidence, and increase eCommerce sales while reducing operational costs.",
        testimonial: { name: "Emily Davis", position: "Lead Designer", text: "Best design app on mobile!" },
        screenshots: [
            EditEZY1,
            EditEZY2,
            EditEZY3,
            EditEZY4,
            EditEZY5,
            EditEZY6,
            EditEZY7,
            EditEZY8,
            EditEZY9,
            EditEZY10,
            EditEZY11,
            EditEZY12,
            EditEZY13,
            EditEZY14
        ],
        videoId: "F_8uNhi-_n4",
        BackgroundImage: EditEZY,
    },
    {
        id: 10, 
        title: "Varahi Self Drive Cars – Self-Drive Car Rental Platform", 
        type: "app",
        description: "Varahi Self Drive Cars is a premium self-drive car rental platform that offers affordable and flexible car rental services in Hyderabad. Customers can book well-maintained hatchbacks, sedans, SUVs, and luxury vehicles for daily, weekly, or monthly rentals through a simple online booking process.",
        fullDescription: "Varahi Self Drive Cars is a self-drive vehicle rental platform designed to provide a convenient, reliable, and hassle-free travel experience. The platform offers a wide range of vehicles, including economy cars, sedans, SUVs, and luxury cars, catering to personal, business, and leisure travel needs. Customers can easily browse available vehicles, book online, and choose flexible rental durations ranging from one day to several months. With transparent pricing, comprehensive insurance coverage, secure online booking, and 24/7 customer support, Varahi Self Drive Cars ensures a safe and comfortable driving experience. The platform focuses on customer convenience by providing quick pickup and drop-off services, well-maintained vehicles, and a seamless rental process through both its website and mobile application.",
        image: "/assets/portfolio/carrentlogo.png", 
        icon: "/assets/portfolio/carrentlogo.png",
        playstoreLink: "https://play.google.com/store/apps/details?id=com.self_drive_cars",
        appstoreLink: "https://apps.apple.com/in/app/varahi-self-drive-cars/id6753347255",
        client: "Varahi Cabs",
        category: "Car Rental, Self-Drive Car Rental, Travel & Transportation, Vehicle Rental, Mobility Services",
        year: "2024",
        duration: "4 Months",
        technologies: ["React Native", "Firebase", "Node.js", "MongoDB", "Google Maps"],
        features: [
            "Online self-drive car booking",
            "Wide range of vehicles (Hatchbacks, Sedans, SUVs, Luxury Cars)",
            "Daily, weekly, and monthly rental plans",
            "Flexible rental durations",
            "Affordable pricing with no hidden charges",
            "Comprehensive insurance coverage",
            "Secure online booking and payments",
            "Quick pickup and drop-off",
            "Well-maintained vehicles",
            "Real-time vehicle availability",
            "24/7 customer support",
            "Multiple vehicle categories",
            "Mobile app for Android and iOS",
            "Transparent pricing",
            "Easy booking process",
            "Privacy without a driver",
            "Convenient Hyderabad locations",
            "Business and personal travel solutions"
        ],
        results: { "Bookings": "+250%", "Vehicles": "+100", "Users": "+8000", "Rating": "4.7/5" },
        challenges: "Limited flexibility with chauffeur-driven rental services. Difficulty finding reliable and well-maintained self-drive vehicles. Hidden charges and complicated rental procedures. Limited vehicle options for different travel requirements. Time-consuming offline booking processes.",
        solution: "Varahi Self Drive Cars solves these challenges by offering a fully digital self-drive car rental platform with a diverse fleet of well-maintained vehicles, transparent pricing, flexible rental plans, comprehensive insurance, and a simple online booking process. Customers enjoy complete privacy, convenience, and the freedom to travel at their own pace without relying on a driver.",
        testimonial: { name: "Rahul Patel", position: "CEO, Varahi Cabs", text: "Perfect solution for self-drive!" },
        screenshots: [
            Varahi1,
            Varahi2,
            Varahi3,
            Varahi4,
            Varahi5,
            Varahi6,
            Varahi7,
            Varahi8,
            Varahi9,
            Varahi10
        ],
        videoId: "QcvN_Pc4ue8",
        BackgroundImage: Varahi,
    },
    {
        id: 11, 
        title: "Techsterker – IT Training & Career Development Platform", 
        type: "website",
        description: "Techsterker is an online IT training and career development platform that provides industry-focused courses in emerging technologies such as Data Science, Full Stack Python, Generative AI, and Data Analytics. The platform emphasizes practical learning, expert mentorship, and placement support to help students build successful careers in the technology industry.",
        fullDescription: "Techsterker is an EdTech platform designed to bridge the gap between academic learning and industry requirements. It offers instructor-led online training programs, hands-on projects, live classes, personalized mentorship, and career guidance across in-demand technologies. Students can enroll in certified courses such as Data Science, Full Stack Python, Generative AI, and Data Analytics, while gaining practical experience through assignments, hackathons, group labs, and real-world simulations. The platform also provides one-to-one mentor support, an integrated Learning Management System (LMS), resume preparation, mock interviews, and placement assistance to improve employability. Techsterker focuses on delivering practical, job-oriented education that prepares learners for successful careers in the IT sector.",
        image: "/assets/portfolio/tech.png", 
        icon: "/assets/portfolio/techlogo.png",
        websiteLink: "https://techsterker.com/",
        client: "Techsterker Academy",
        category: "EdTech, Online Learning, IT Training, Professional Certification, Career Development, Skill Development",
        year: "2024",
        duration: "3 Months",
        technologies: ["React", "Node.js", "MongoDB", "AWS", "Zoom API"],
        features: [
            "Online instructor-led live classes",
            "Certified IT training programs",
            "Data Science course",
            "Full Stack Python course",
            "Generative AI course",
            "Data Analyst course",
            "Personalized learning plans",
            "Learning Management System (LMS)",
            "Hands-on practical projects",
            "Group labs and hackathons",
            "One-to-one mentor support",
            "Mock interviews",
            "Resume building assistance",
            "Placement support",
            "Industry-expert trainers",
            "Flexible online learning",
            "Anytime student support",
            "Certification upon course completion",
            "Real-world simulations and assignments",
            "Career guidance and counseling"
        ],
        results: { "Students": "+3000", "Courses": "+50", "Completion": "92%", "Rating": "4.9/5" },
        challenges: "Gap between academic education and industry requirements. Limited practical exposure in traditional learning. Difficulty finding job-oriented IT training. Lack of mentorship and career guidance. Insufficient hands-on experience with modern technologies. Challenges in securing placements after course completion.",
        solution: "Techsterker addresses these challenges by offering industry-relevant, project-based IT training with expert instructors, live online classes, practical assignments, personalized mentorship, mock interviews, resume support, and placement assistance. Its comprehensive learning approach equips students with the technical and professional skills required to succeed in today's competitive IT job market.",
        testimonial: { name: "Dr. Smith", position: "Dean, Techsterker", text: "Best platform for tech education!" },
        screenshots: [
            Tech1,
            Tech2,
            Tech3,
            Tech4,
            Tech5,
            Tech3,
            Tech6,
            Tech7,
            Tech8,
            Tech9,
            Tech10,
            Tech11,
        ],
        BackgroundImage: Tech,
    },
    {
        id: 12, 
        title: "Dharmadhwajam – Digital News & Media Platform", 
        type: "app",
        description: "Dharmadhwajam is a digital news platform that delivers fast, accurate, and unbiased news coverage across Telangana, Andhra Pradesh, India, and the world. It provides news through articles, videos, posters, and infographics, offering users a modern and engaging way to stay informed.",
        fullDescription: "Dharmadhwajam is a comprehensive digital news and media platform designed to provide reliable, fact-based journalism in an easy-to-consume format. The platform publishes breaking news, regional updates, national and international news, editorials, opinion pieces, video reports, and visually rich posters and infographics. Users can browse articles, watch video news, bookmark their favorite content, and access premium features through subscription plans. With a focus on verified reporting, user-friendly navigation, and multiple content formats, Dharmadhwajam aims to keep readers informed while combating misinformation and delivering trustworthy journalism.",
        image: "/assets/portfolio/news.png", 
        icon: "/assets/portfolio/news.png",
        playstoreLink: "https://play.google.com/store/apps/details?id=com.dhama.dharmadhvajam",
        appstoreLink: "https://apps.apple.com/in/app/dharmadhwajam/id6756093088",
        client: "Dharmadwajam Media",
        category: "News & Media, Digital News Portal, Online News Platform, Journalism, Media & Publishing",
        year: "2024",
        duration: "3 Months",
        technologies: ["React Native", "Firebase", "Node.js", "MongoDB"],
        features: [
            "Breaking news updates",
            "Regional news (Telangana & Andhra Pradesh)",
            "National and international news",
            "Video news coverage",
            "News posters and infographics",
            "Editorials and opinion articles",
            "Bookmark favorite content",
            "Premium subscription plans",
            "User-friendly mobile application",
            "Fast and reliable news delivery",
            "Fact-based journalism",
            "Clean and modern interface",
            "Search and browse news categories",
            "Real-time content updates",
            "Mobile-friendly experience",
            "Secure user accounts",
            "Android and iOS app support"
        ],
        results: { "Users": "+12000", "Articles": "+500", "Engagement": "4.5/5", "Shares": "+10000" },
        challenges: "Spread of misinformation and unreliable news sources. Difficulty accessing verified news in one place. Traditional news platforms often lack engaging content formats. Users want quick updates without information overload. Limited access to quality regional news alongside national and global coverage.",
        solution: "Dharmadhwajam addresses these challenges by offering a trusted digital news platform that combines verified journalism with engaging content formats such as articles, videos, posters, and infographics. It enables users to consume accurate news quickly while providing premium features, bookmarks, and an intuitive experience for staying informed anytime and anywhere.",
        testimonial: { name: "Ananya Reddy", position: "Editor", text: "Great platform for meaningful content!" },
        screenshots: [
            Narada1,
            Narada2,
            Narada3,
            Narada4,
            Narada5,
            Narada6,
            Narada7,
            Narada8,
            Narada9,
            Narada10,
            Narada11
        ],
        BackgroundImage: Narada,
        videoId: "ObYJ9K53HEA"
    },
    {
        id: 13, 
        title: "Backup Ticket – Ticket Resale & Marketplace Platform", 
        type: "app",
        description: "Backup Ticket is a secure online marketplace that enables users to buy and sell unused movie tickets, bus tickets, and similar items. The platform provides a safe, reliable, and hassle-free way to recover ticket costs or purchase genuine tickets at better prices through verified transactions.",
        fullDescription: "Backup Ticket is a peer-to-peer ticket marketplace designed for users who need to resell unused tickets or purchase tickets from other verified users. The platform supports movie tickets, bus tickets, and similar items, allowing sellers to create listings with images, prices, and ticket details while buyers can browse available listings and complete purchases securely. Payments are processed through Razorpay for safe transactions, and users can manage their listings, view transaction history, and maintain secure profiles. With a marketplace experience similar to classified platforms, Backup Ticket simplifies ticket resale while reducing wastage and helping buyers find genuine tickets at affordable prices.",
        image: "/assets/portfolio/atoz.png", 
        icon: "/assets/portfolio/atoz.png",
        playstoreLink: "https://play.google.com/store/apps/details?id=com.backup.backup_ticket",
        client: "BackUp Events",
        category: "Ticket Marketplace, Ticket Resale Platform, Online Marketplace, Entertainment, Travel, E-commerce",
        year: "2024",
        duration: "4 Months",
        technologies: ["Flutter", "Firebase", "Node.js", "PostgreSQL", "Stripe"],
        features: [
            "Buy and sell movie tickets",
            "Buy and sell bus tickets",
            "Ticket resale marketplace",
            "User-generated ticket listings",
            "Upload ticket images and details",
            "Secure online payments (Razorpay)",
            "Digital transaction history",
            "User profile management",
            "Verified user accounts",
            "Easy listing management",
            "Clean and user-friendly interface",
            "Safe and reliable transactions",
            "Fraud prevention measures",
            "Personal data protection",
            "Account deletion option",
            "Mobile application for Android"
        ],
        results: { "Users": "+8000", "Tickets Sold": "+15000", "Trust Score": "98%", "Rating": "4.6/5" },
        challenges: "Unused tickets often go to waste due to last-minute plan changes. Buyers struggle to find genuine tickets at reasonable prices. Existing resale methods lack trust and security. Safe payment handling between buyers and sellers is difficult. Managing ticket resale through informal channels increases fraud risk.",
        solution: "Backup Ticket addresses these challenges by providing a dedicated marketplace where users can securely buy and sell unused tickets. The platform offers verified user accounts, secure Razorpay payment processing, transparent listings, and fraud prevention measures, creating a trusted ecosystem that helps sellers recover costs while enabling buyers to purchase genuine tickets conveniently and safely.",
        testimonial: { name: "James Brown", position: "Founder", text: "Secure and reliable ticket platform!" },
        screenshots: [
            Back1,
            Back2,
            Back3,
            Back4,
            Back5,
            Back6,
            Back7,
            Back8,
            Back9,
            Back10,
            Back11
        ],
        BackgroundImage: Backup,
        videoId: "fPOW_YzYiIc"
    },
    // {
    //     id: 17, 
    //     title: "Nupura Self Drive Cars – Self-Drive Car Rental Platform", 
    //     type: "app",
    //     description: "Nupura Self Drive Cars is a self-drive car rental platform that provides affordable, reliable, and flexible vehicle rental services. Customers can book well-maintained cars for personal, business, weekend, and outstation travel through a simple online booking system with transparent pricing and convenient rental options.",
    //     fullDescription: "Nupura Self Drive Cars is a modern mobility platform designed to offer a seamless self-drive car rental experience. The platform enables users to browse available vehicles, select their preferred rental duration, and book cars online with minimal paperwork. It offers a fleet of hatchbacks, sedans, SUVs, and premium vehicles suitable for city commuting, family trips, business travel, and long-distance journeys. With flexible rental plans, transparent pricing, secure bookings, and customer support, Nupura Self Drive Cars focuses on providing customers with complete driving freedom, convenience, and reliability while maintaining high standards of vehicle quality and safety.",
    //     image: "/assets/portfolio/carservicelogo.png", 
    //     icon: "/assets/portfolio/carservicelogo.png",
    //     playstoreLink: "https://play.google.com/store/apps/details?id=com.nupura.nupura_cars",
    //     appstoreLink: "https://apps.apple.com/in/app/nupura-cars/id6758536789",
    //     client: "Nupura Motors",
    //     category: "Car Rental, Self-Drive Car Rental, Travel & Transportation, Vehicle Rental, Mobility Services",
    //     year: "2024",
    //     duration: "3 Months",
    //     technologies: ["React Native", "Node.js", "MongoDB", "Google Maps"],
    //     features: [
    //         "Online self-drive car booking",
    //         "Wide range of vehicles (Hatchbacks, Sedans, SUVs, Premium Cars)",
    //         "Daily, weekly, and monthly rental options",
    //         "Flexible rental durations",
    //         "Affordable and transparent pricing",
    //         "Easy online reservation",
    //         "Well-maintained vehicles",
    //         "Secure booking process",
    //         "Business and leisure travel support",
    //         "Weekend and outstation rentals",
    //         "Real-time vehicle availability",
    //         "Customer support",
    //         "Convenient pickup and return",
    //         "Minimal paperwork",
    //         "Mobile-friendly booking platform",
    //         "Safe and reliable travel experience"
    //     ],
    //     results: { "Services": "+5000", "Customers": "+7000", "Satisfaction": "96%", "Response": "10min" },
    //     challenges: "Limited flexibility with traditional chauffeur-driven rentals. Difficulty finding reliable self-drive rental services. Hidden charges and complex rental procedures. Limited vehicle availability during peak periods. Time-consuming offline booking processes.",
    //     solution: "Nupura Self Drive Cars simplifies vehicle rentals by offering a digital self-drive booking platform with flexible rental plans, transparent pricing, and a diverse fleet of well-maintained vehicles. Customers can book cars quickly, enjoy complete driving freedom, and experience a hassle-free travel solution for personal, business, and leisure trips.",
    //     testimonial: { name: "Vikram Singh", position: "CEO, Nupura Motors", text: "Best car service platform!" },
    //     screenshots: [
    //         Nupura1,
    //         Nupura2
    //     ],
    //     BackgroundImage: bannerImage,
    // },
    {
        id: 22, 
        title: "CLYNIX – Online Medicine Delivery & Pharmacy Platform", 
        type: "app",
        description: "CLYNIX is an online pharmacy and medicine delivery platform that connects users with verified and licensed pharmacies. It enables customers to order medicines, upload prescriptions, schedule recurring deliveries, and receive healthcare essentials quickly and securely at their doorstep.",
        fullDescription: "CLYNIX is a digital healthcare application designed to simplify medicine ordering and pharmacy access. Users can browse nearby licensed pharmacies, search medicines by category or name, upload doctor prescriptions or medicine photos, and place secure online orders. The platform supports recurring medicine delivery plans for patients with long-term medication needs and offers multiple payment options, including online payments and Cash on Delivery. Prescription medicines are dispensed only after pharmacist verification, ensuring compliance with healthcare regulations. With fast doorstep delivery, secure ordering, and an easy-to-use interface, CLYNIX aims to make healthcare more accessible and convenient.",
        image: "/assets/portfolio/clynixlogo.png", 
        icon: "/assets/portfolio/clynixlogo.png",
        playstoreLink: "https://play.google.com/store/apps/details?id=com.clynix.clynix",
        client: "Clynix Health",
        category: "Healthcare, Online Pharmacy, Medicine Delivery, HealthTech, Medical Services, E-commerce",
        year: "2024",
        duration: "5 Months",
        technologies: ["React Native", "Node.js", "MongoDB", "Firebase", "Stripe"],
        features: [
            "Online medicine ordering",
            "Browse nearby verified pharmacies",
            "Search medicines by category or name",
            "Upload doctor prescriptions",
            "Upload medicine photos for quick ordering",
            "Secure shopping cart and checkout",
            "Weekly and monthly recurring medicine plans",
            "Fast doorstep medicine delivery",
            "Verified licensed pharmacy network",
            "Prescription verification by pharmacists",
            "Online payment support (Razorpay)",
            "Cash on Delivery (COD)",
            "User account management",
            "Order tracking",
            "Mobile-friendly application",
            "Secure healthcare platform",
            "Reliable customer support"
        ],
        results: { "Orders": "+8000", "Pharmacies": "+300", "Users": "+12000", "Rating": "4.8/5" },
        challenges: "Difficulty accessing medicines quickly from trusted pharmacies. Manual prescription handling and pharmacy visits are time-consuming. Patients often forget to refill recurring medications. Limited access to a reliable online pharmacy network. Managing prescription medicines while ensuring regulatory compliance.",
        solution: "CLYNIX addresses these challenges by connecting users with verified pharmacies through a secure digital platform. Customers can upload prescriptions, order medicines online, schedule recurring deliveries, choose convenient payment options, and receive medicines at their doorstep. The platform simplifies medication management while ensuring prescription verification and safe delivery through licensed pharmacy partners.",
        testimonial: { name: "Dr. Mehta", position: "Medical Director", text: "Revolutionary healthcare platform!" },
        screenshots: [
            Cynix1,
            Cynix2,
            Cynix3,
            Cynix4,
            Cynix5,
            Cynix6,
            Cynix7,
            Cynix8,
        ],
        BackgroundImage: Simcura,
    },
    {
        id: 14, 
        title: "SS Air Conditioners – Commercial & Industrial HVAC Solutions", 
        type: "digital",
        description: "SS Air Conditioners is a leading HVAC solutions provider specializing in commercial, industrial, and residential air conditioning services. The company offers end-to-end HVAC design, installation, maintenance, repair, and energy-efficient cooling solutions for businesses across India.",
        fullDescription: "SS Air Conditioners is a trusted HVAC company with over 20 years of industry experience, delivering premium air conditioning and ventilation solutions for commercial, industrial, corporate, and residential clients. The company specializes in HVAC system design, VRF/VRV air conditioning installation, inverter AC installation, commercial cooling systems, preventive maintenance, emergency AC repair, and AMC (Annual Maintenance Contracts). With a team of certified professionals, SS Air Conditioners provides customized, energy-efficient cooling solutions tailored to offices, factories, retail spaces, hospitals, educational institutions, and other commercial establishments. The company is committed to quality workmanship, reliable customer support, and sustainable HVAC technologies that improve comfort while reducing operational costs.",
        image: "/assets/portfolio/ss.png", 
        icon: "/assets/portfolio/sslogo.png",
        websiteLink: "https://www.ssairconditioners.com/",
        client: "SS Air Conditioners",
        category: "HVAC Services, Air Conditioning, Commercial HVAC, Industrial Cooling, Mechanical Engineering, Facility Management",
        year: "2024",
        duration: "2 Months",
        technologies: ["SEO", "Google Ads", "Social Media", "Content Marketing"],
        features: [
            "Commercial HVAC system installation",
            "Industrial cooling solutions",
            "Residential AC installation",
            "VRF/VRV AC system installation",
            "Inverter AC installation",
            "HVAC system design and consultation",
            "24/7 emergency AC repair",
            "AC gas leakage detection and refilling",
            "Preventive maintenance services",
            "Annual Maintenance Contracts (AMC)",
            "Energy-efficient cooling solutions",
            "Air conditioning system upgrades",
            "Corporate HVAC projects",
            "Industrial HVAC projects",
            "Certified HVAC technicians",
            "Customized cooling solutions",
            "Professional project execution",
            "Quality equipment and installation",
            "Nationwide commercial support",
            "Dedicated customer assistance"
        ],
        results: { "Traffic": "+200%", "Leads": "+150%", "Conversion": "+45%", "ROI": "400%" },
        challenges: "High energy consumption from outdated HVAC systems. Frequent AC breakdowns affecting business operations. Difficulty finding reliable commercial HVAC contractors. Inefficient cooling increases operational costs. Businesses require customized HVAC solutions for different environments. Lack of timely maintenance leads to equipment failures.",
        solution: "SS Air Conditioners addresses these challenges by delivering complete HVAC solutions, including system design, installation, maintenance, emergency repairs, and energy-efficient upgrades. With experienced engineers, customized project execution, and 24/7 technical support, the company helps businesses achieve reliable cooling performance, reduced energy costs, and long-term operational efficiency.",
        testimonial: { name: "Mr. Sharma", position: "Owner", text: "Amazing digital marketing results!" },
        screenshots: [
            ss1,
            ss2,
            ss3,
            ss4,
            ss5,
            ss6,
            ss7,
            ss8
        ],
        BackgroundImage: SSAir,
    },
    {
        id: 23, 
        title: "SimcuraRX – Integrated Healthcare & IT Solutions Platform", 
        type: "website",
        description: "SimcuraRX is a healthcare and technology company that combines medical services with digital solutions. The platform offers doctor consultations, medicine delivery, diagnostics, healthcare software development, mobile app development, website development, digital marketing, and enterprise IT solutions for healthcare providers and businesses.",
        fullDescription: "SimcuraRX Pvt. Ltd. is an integrated healthcare and IT solutions company focused on delivering accessible healthcare services alongside innovative digital technologies. The platform provides doctor consultations, medicine delivery, diagnostic services, and healthcare applications while also offering custom software development, mobile app development, website development, e-commerce solutions, and digital marketing services. Through its healthcare companion application, Clynix, SimcuraRX helps patients manage medications and healthcare schedules. The company partners with healthcare providers, startups, and enterprises to build scalable digital solutions that improve patient care, streamline operations, and accelerate business growth. Its mission is to bridge the gap between healthcare and technology through secure, reliable, and innovative services.",
        image: "/assets/portfolio/clynixlogo.png", 
        icon: "/assets/portfolio/clynixlogo.png",
        websiteLink: "https://www.simcurarx.com/",
        client: "Clynix Health",
        category: "Healthcare Technology, HealthTech, IT Services, Software Development, Digital Healthcare, Enterprise Solutions",
        year: "2024",
        duration: "4 Months",
        technologies: ["React", "Node.js", "MongoDB", "AWS", "Stripe"],
        features: [
            "Doctor consultation services",
            "Medicine delivery solutions",
            "Diagnostic services",
            "Clynix healthcare companion app",
            "Custom healthcare software development",
            "Mobile app development (Android & iOS)",
            "Website development",
            "E-commerce solutions",
            "Digital marketing services",
            "Enterprise IT solutions",
            "API integration services",
            "Healthcare workflow automation",
            "Scalable cloud-based solutions",
            "Secure healthcare data management",
            "B2B healthcare services",
            "Startup technology support",
            "Healthcare provider partnerships",
            "End-to-end digital transformation",
            "Dedicated technical support"
        ],
        results: { "Orders": "+8000", "Pharmacies": "+300", "Users": "+12000", "Rating": "4.8/5" },
        challenges: "Fragmented healthcare and technology services. Manual healthcare workflows reduce operational efficiency. Limited access to integrated digital healthcare solutions. Healthcare organizations require secure and scalable IT infrastructure. Businesses struggle to find a single partner for healthcare and technology needs.",
        solution: "SimcuraRX addresses these challenges by providing an integrated ecosystem that combines healthcare services with advanced IT solutions. From patient care and diagnostics to custom software development, mobile applications, enterprise systems, and digital transformation, the platform enables healthcare providers and businesses to improve efficiency, enhance patient experiences, and scale operations through a single trusted technology partner.",
        testimonial: { name: "Dr. Mehta", position: "Medical Director", text: "Revolutionary healthcare platform!" },
        screenshots: [
            Simcurax1,
            Simcurax2,
            Simcurax3,
            Simcurax4,
            Simcurax5
        ],
        BackgroundImage: Simcura,
    },
    {
        id: 15, 
        title: "EditEZY – Online Graphic Design Platform", 
        type: "website",
        description: "EditEZY is an easy-to-use poster and graphic design platform helping users create eye-catching posters, banners, and social media creatives in minutes.",
        fullDescription: "EditEZY is a comprehensive online graphic design platform that empowers users to create professional-quality visuals without prior design experience. With a vast library of ready-made templates, drag-and-drop editing tools, and powerful customization features, users can design posters, banners, social media posts, and marketing materials in minutes. The platform bridges the gap between complex design software and simple mobile apps by offering robust web-based tools accessible from any browser. It serves freelancers, small businesses, marketers, and content creators who need quick, high-quality designs for their digital presence.",
        image: "/assets/portfolio/editezy.png", 
        icon: "/assets/portfolio/editezy.png",
        websiteLink: "https://editezy.com/",
        client: "EditEZY Studios",
        category: "Graphic Design, Web Application, SaaS, Creative Tools, Marketing",
        year: "2024",
        duration: "6 Months",
        technologies: ["React", "Node.js", "Canvas API", "AWS S3", "Tailwind CSS"],
        features: [
            "Web-based design editor",
            "Thousands of ready-made templates",
            "Drag-and-drop interface",
            "Customizable fonts and colors",
            "Social media size presets",
            "High-resolution exports",
            "Cloud storage for projects",
            "Collaboration tools",
            "Brand kit management",
            "Stock photo integration",
            "Responsive design preview",
            "Easy sharing options",
            "No installation required",
            "Cross-browser compatibility",
            "Affordable subscription plans"
        ],
        results: { "Users": "+50000", "Designs Created": "+1M", "Retention": "85%", "Rating": "4.7/5" },
        challenges: "Users find professional design software too complex and expensive. Mobile apps often lack advanced features needed for desktop workflows. Businesses need consistent branding across multiple platforms. Quick turnaround time is essential for social media marketing.",
        solution: "EditEZY provides a powerful yet intuitive web-based design platform that combines ease of use with professional capabilities. By offering pre-sized templates, drag-and-drop functionality, and cloud-based project management, it enables users to create stunning visuals quickly and efficiently from any device.",
        testimonial: { name: "Sarah Lee", position: "Marketing Manager", text: "The best web tool for quick designs!" },
        screenshots: [
            editweb1,
            editweb2
        ],
        BackgroundImage: EditEZY,
    },
    {
        id: 16, 
        title: "Varahi SelfDriveCars – Official Website", 
        type: "website",
        description: "Varahi SelfDriveCars is a premier car rental service offering a wide range of self-drive vehicles for leisure and business travelers.",
        fullDescription: "The Varahi SelfDriveCars official website serves as the primary digital gateway for customers seeking reliable self-drive car rental services in Hyderabad. The platform showcases the extensive fleet of vehicles, including hatchbacks, sedans, SUVs, and luxury cars, with detailed specifications and pricing. Users can browse availability, compare vehicles, read customer reviews, and book rentals directly through the secure online system. The website emphasizes transparency, convenience, and customer satisfaction, providing detailed information on rental policies, insurance coverage, and pickup locations. It integrates seamlessly with the mobile app to offer a unified experience for both web and mobile users.",
        image: "/assets/portfolio/carrentlogo.png", 
        icon: "/assets/portfolio/carrentlogo.png",
        websiteLink: "https://varahiselfdrivecars.com/",
        client: "Varahi Cabs",
        category: "Car Rental, Travel, Transportation, Web Portal, Booking System",
        year: "2024",
        duration: "4 Months",
        technologies: ["React", "Node.js", "MongoDB", "Google Maps API", "Stripe"],
        features: [
            "Comprehensive vehicle catalog",
            "Real-time availability check",
            "Online booking system",
            "Detailed pricing breakdown",
            "Customer reviews and ratings",
            "Rental policy information",
            "Insurance details",
            "Pickup location maps",
            "FAQ and support section",
            "Mobile-responsive design",
            "Secure payment gateway",
            "User account management",
            "Booking history tracking",
            "Promotional offers display",
            "SEO optimized content"
        ],
        results: { "Traffic": "+200%", "Bookings": "+150%", "Conversion": "4.5%", "Speed": "1.5s" },
        challenges: "Customers need detailed information before booking. Trust is crucial for self-drive rentals. Mobile-only apps limit access for desktop users. SEO visibility is key for local search traffic.",
        solution: "The Varahi website provides a robust, informative, and user-friendly platform that builds trust through transparency. By offering detailed vehicle info, clear pricing, and easy booking, it captures desktop traffic and complements the mobile app, driving overall business growth.",
        testimonial: { name: "Rahul Patel", position: "CEO, Varahi Cabs", text: "Our website drives significant bookings!" },
        screenshots: [
            Varahiweb1,
            Varahiweb2,
            Varahiweb3,
            Varahiweb4,
            Varahiweb5,
            Varahiweb6
        ],
        BackgroundImage: Varahi,
    },
    {
        id: 18, 
        title: "Vegiffyy – Vegetarian Food Delivery Website", 
        type: "website",
        description: "Vegiffyy is a cutting-edge mobile food delivery application focused on fresh, hygienic, and delicious vegetarian meals.",
        fullDescription: "The Vegiffyy website extends the brand's mission of providing 100% pure vegetarian food delivery to a broader audience. It serves as an informational hub and ordering platform for users who prefer browsing on desktop. The site features a curated list of verified vegetarian restaurants, cloud kitchens, and sweet shops. Users can explore menus, read about the hygiene standards, learn about the vendor partnership program, and place orders. The website highlights the company's commitment to quality, purity, and community support, offering a seamless experience for health-conscious consumers and potential business partners.",
        image: "/assets/portfolio/veg.jpeg", 
        icon: "/assets/portfolio/veglogo.png",
        websiteLink: "https://vegiffy.com/",
        client: "Vegiffy Foods",
        category: "Food Delivery, E-commerce, Vegetarian Dining, Restaurant Marketplace",
        year: "2024",
        duration: "5 Months",
        technologies: ["React", "Node.js", "MongoDB", "Redux", "Tailwind CSS"],
        features: [
            "Online food ordering",
            "Restaurant listings and menus",
            "Vendor registration portal",
            "Delivery partner sign-up",
            "Hygiene and quality standards info",
            "Customer testimonials",
            "Blog and nutrition tips",
            "Search and filter options",
            "Secure checkout",
            "Order tracking integration",
            "Responsive web design",
            "SEO friendly structure",
            "Promotional campaigns",
            "Customer support chat",
            "Multi-city availability info"
        ],
        results: { "Traffic": "+180%", "Orders": "+25%", "Vendor Signups": "+50", "Rating": "4.8/5" },
        challenges: "Desktop users want a full browsing experience. Need to attract vendors and delivery partners. Building trust in food purity online. Competing with general food delivery platforms.",
        solution: "The Vegiffyy website offers a specialized, trustworthy platform for vegetarian food lovers. By highlighting verification processes, offering easy vendor onboarding, and providing a smooth ordering experience, it strengthens the brand's position as the go-to destination for pure vegetarian dining.",
        testimonial: { name: "Priya Sharma", position: "CEO, Vegiffyy", text: "Our web presence has grown significantly!" },
        screenshots: [
            vegweb1,
            vegweb2,
            vegweb3,
            vegweb4,
            vegweb5,
            vegweb6,
            vegweb7
        ],
        BackgroundImage: VEG,
    },
    {
        id: 19, 
        title: "Redemly – Rewards Platform Website", 
        type: "website",
        description: "Redemly simplifies redeeming rewards, discounts, and offers from various brands and retailers.",
        fullDescription: "The Redemly website serves as the central hub for its gamified rewards ecosystem. It allows users to learn more about how to earn coins through walking, quizzes, and daily activities. The site features a directory of participating local businesses, detailed explanations of the reward redemption process, and a portal for merchants to join the network. With a clean, engaging design, the website educates users on the benefits of supporting local businesses while saving money. It also provides resources for businesses looking to increase customer loyalty through the Redemly Pro program.",
        image: "/assets/portfolio/redemly.png", 
        icon: "/assets/portfolio/redemlylogo.png",
        websiteLink: "https://redemly.com/",
        client: "Redemly Inc",
        category: "Loyalty Program, Local Business, Gamification, Web Portal",
        year: "2024",
        duration: "4 Months",
        technologies: ["React", "Firebase", "Node.js", "GraphQL"],
        features: [
            "How-it-works guide",
            "Participating business directory",
            "Merchant onboarding portal",
            "Redemly Pro information",
            "User testimonials",
            "Blog on savings and health",
            "FAQ section",
            "Download app links",
            "Secure user login",
            "Reward balance check",
            "Newsletter subscription",
            "Contact support",
            "Privacy policy",
            "Terms of service",
            "Interactive coin calculator"
        ],
        results: { "Visitors": "+30000", "Merchant Signups": "+100", "App Downloads": "+5000", "Engagement": "High" },
        challenges: "Explaining the gamified model clearly. Attracting local businesses to the platform. Driving app downloads from web traffic. Maintaining user interest.",
        solution: "The Redemly website effectively communicates the value proposition through clear visuals and interactive elements. By showcasing success stories and providing easy access for both users and merchants, it acts as a powerful acquisition channel for the mobile app and the B2B merchant network.",
        testimonial: { name: "Alex Chen", position: "Founder, Redemly", text: "The website perfectly complements our app!" },
        screenshots: [
            Redemlyweb1,
            Redemlyweb2,
            Redemlyweb3,
            Redemlyweb4,
            Redemlyweb5
        ],
        BackgroundImage: Redemly,
    },
    {
        id: 20, 
        title: "EditEZY – Professional Design Services Website", 
        type: "website",
        description: "EditEZY is an easy-to-use poster and graphic design platform helping users create eye-catching posters, banners, and social media creatives.",
        fullDescription: "This iteration of the EditEZY website focuses on its professional design services and enterprise solutions. While the app targets individual creators, the website highlights bulk editing services, API integrations for e-commerce platforms, and custom design packages for agencies. It showcases case studies, before-and-after examples, and detailed service descriptions for background removal, retouching, and product photography enhancement. The site is designed to convert B2B clients by demonstrating reliability, speed, and cost-effectiveness.",
        image: "/assets/portfolio/editezy.png", 
        icon: "/assets/portfolio/editezy.png",
        websiteLink: "https://editezy.com/",
        client: "EditEZY Studios",
        category: "B2B Services, Photo Editing, E-commerce Solutions, Digital Agency",
        year: "2024",
        duration: "6 Months",
        technologies: ["Next.js", "Node.js", "PostgreSQL", "AWS"],
        features: [
            "B2B service packages",
            "API documentation",
            "Case studies and portfolio",
            "Bulk upload tool",
            "Enterprise pricing",
            "Client dashboard",
            "Quality guarantee",
            "Turnaround time SLA",
            "Dedicated account manager",
            "Integration guides",
            "Testimonials from brands",
            "Blog on e-commerce trends",
            "Contact sales form",
            "Live chat support",
            "Secure file transfer"
        ],
        results: { "B2B Clients": "+50", "Revenue": "+40%", "Retention": "95%", "Satisfaction": "4.9/5" },
        challenges: "Convincing enterprises of quality and security. Managing large volume requests. Integrating with diverse e-commerce platforms. Competitive pricing pressure.",
        solution: "The EditEZY website builds credibility through transparent processes, robust security features, and proven case studies. By offering tailored enterprise solutions and dedicated support, it positions itself as a reliable partner for high-volume image editing needs.",
        testimonial: { name: "Emily Davis", position: "Lead Designer", text: "Essential for our workflow!" },
        screenshots: [
            editweb1,
            editweb2
        ],
        BackgroundImage: EditEZY,
    },
    {
        id: 21, 
        title: "Varahi SelfDriveCars – Corporate & Fleet Solutions", 
        type: "website",
        description: "Varahi SelfDriveCars is a premier car rental service offering a wide range of self-drive vehicles for leisure and business travelers.",
        fullDescription: "This specialized section of the Varahi website caters to corporate clients and fleet managers. It offers tailored solutions for business travel, employee transportation, and long-term leasing. The platform provides detailed reporting, centralized billing, and priority support for corporate accounts. It highlights the safety, maintenance, and variety of the fleet, ensuring businesses can rely on Varahi for their mobility needs. The site also features information on insurance, liability, and compliance for corporate rentals.",
        image: "/assets/portfolio/carrentlogo.png", 
        icon: "/assets/portfolio/carrentlogo.png",
        websiteLink: "https://varahiselfdrivecars.com/",
        client: "Varahi Cabs",
        category: "Corporate Travel, Fleet Management, B2B Rental, Transportation",
        year: "2024",
        duration: "4 Months",
        technologies: ["React", "Node.js", "MongoDB", "Excel Export"],
        features: [
            "Corporate account management",
            "Centralized billing",
            "Monthly usage reports",
            "Priority booking",
            "Dedicated support line",
            "Long-term leasing options",
            "Employee travel policy integration",
            "Fleet customization",
            "Invoice generation",
            "Multi-user access",
            "Safety and compliance docs",
            "Vehicle maintenance logs",
            "Cost-saving analysis",
            "Contract management",
            "24/7 emergency support"
        ],
        results: { "Corporate Clients": "+20", "Fleet Size": "+50", "Revenue": "+30%", "Efficiency": "High" },
        challenges: "Meeting diverse corporate compliance requirements. Providing detailed reporting. Ensuring vehicle availability for bulk bookings. Managing complex billing structures.",
        solution: "The Varahi corporate portal streamlines business rentals with automated reporting, flexible billing, and dedicated support. It ensures businesses have reliable, compliant, and cost-effective mobility solutions for their teams.",
        testimonial: { name: "Rahul Patel", position: "CEO, Varahi Cabs", text: "A game-changer for corporate clients!" },
        screenshots: [
            Varahiweb1,
            Varahiweb2,
            Varahiweb3,
            Varahiweb4,
            Varahiweb5,
            Varahiweb6
        ],
        BackgroundImage: Varahi,
    },
    {
        id: 24, 
        title: "Nupura Car Service – Official Website", 
        type: "website",
        description: "Nupura Car Service is a reliable and affordable car service provider offering a wide range of automotive services.",
        fullDescription: "The Nupura Car Service website provides a comprehensive overview of its automotive services, including self-drive rentals, chauffeur-driven cars, and maintenance packages. Designed for ease of use, the site allows customers to view the fleet, check service areas, read about safety protocols, and book services online. It emphasizes reliability, affordability, and customer satisfaction, featuring testimonials, FAQs, and detailed service descriptions. The website serves as a key touchpoint for building trust and converting visitors into loyal customers.",
        image: "/assets/portfolio/carservicelogo.png", 
        icon: "/assets/portfolio/carservicelogo.png",
        websiteLink: "https://nupuraselfdrivecars.vercel.app/",
        client: "Nupura Motors",
        category: "Car Service, Auto Rental, Transportation, Web Portal",
        year: "2024",
        duration: "3 Months",
        technologies: ["React", "Vercel", "Node.js", "MongoDB"],
        features: [
            "Service catalog",
            "Online booking system",
            "Fleet gallery",
            "Pricing transparency",
            "Customer reviews",
            "Safety guidelines",
            "FAQ section",
            "Contact forms",
            "Location maps",
            "Mobile-responsive design",
            "Fast loading speed",
            "SEO optimization",
            "Blog on car care",
            "Promotional offers",
            "Support ticket system"
        ],
        results: { "Traffic": "+150%", "Bookings": "+100%", "Inquiries": "+200", "Rating": "4.6/5" },
        challenges: "Standing out in a crowded market. Building trust for new customers. Providing clear service information. Ensuring mobile compatibility.",
        solution: "The Nupura website offers a clean, professional, and informative platform that highlights the company's strengths. By making booking easy and information accessible, it enhances customer confidence and drives conversions.",
        testimonial: { name: "Vikram Singh", position: "CEO, Nupura Motors", text: "Our online presence is stronger than ever!" },
        screenshots: [
            Nupuraweb
        ],
        BackgroundImage: Nupura,
    },
    {
        id: 25, 
        title: "Dharmadwajam – News & Media Website", 
        type: "website",
        description: "Dharmadwajam is a digital platform providing news, informative articles, and creative posters focused on culture, society, and awareness.",
        fullDescription: "The Dharmadwajam website is a digital news portal that delivers timely updates on culture, society, politics, and current affairs. With a focus on meaningful content, the site features articles, opinion pieces, video reports, and visually engaging posters. It serves as a hub for readers seeking unbiased, fact-based journalism with a regional focus on Telangana and Andhra Pradesh. The website offers a seamless reading experience with categories, search functionality, and subscription options for premium content. It aims to inform, inspire, and engage the community through high-quality storytelling.",
        image: "/assets/portfolio/news.png", 
        icon: "/assets/portfolio/news.png",
        websiteLink: "https://dharmadhwajam.vercel.app/",
        client: "Dharmadwajam Media",
        category: "News Portal, Media, Journalism, Content Publishing",
        year: "2024",
        duration: "3 Months",
        technologies: ["Next.js", "Firebase", "Node.js", "MongoDB"],
        features: [
            "Breaking news feed",
            "Category-based browsing",
            "Video news section",
            "Poster and infographic gallery",
            "Search functionality",
            "User comments",
            "Subscription plans",
            "Newsletter signup",
            "Social media sharing",
            "Mobile-responsive layout",
            "Fast content delivery",
            "Ad management system",
            "Editorial team profiles",
            "Contact us page",
            "Privacy policy"
        ],
        results: { "Page Views": "+50000", "Subscribers": "+2000", "Engagement": "High", "Shares": "+15000" },
        challenges: "Maintaining editorial integrity. Keeping up with real-time news. Engaging readers in a digital age. Monetizing content effectively.",
        solution: "The Dharmadwajam website provides a robust, fast, and engaging platform for news consumption. By focusing on quality content, visual storytelling, and user experience, it builds a loyal readership and establishes itself as a trusted source of information.",
        testimonial: { name: "Ananya Reddy", position: "Editor", text: "A vital platform for our voice!" },
        screenshots: [
            Naradaweb
        ],
        BackgroundImage: Narada,
    }
];

export default portfolioItems;